module.exports = __webpack_public_path__ + "img/box_pro_seven_6.cf08e5b2.jpg";